import { notification } from 'antd';
import { API_PREFIX } from '../config';
const moment = require("moment");
const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限,请重新登录',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

const FIX_HEADERS = {};
const setFixHeader = (name, value) => {
    FIX_HEADERS[name] = value;
}

const getFixHeader = () => {
    return FIX_HEADERS
}

//这里的写的是响应头的status code如果不是200-300之间，直接抛出错误
const checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;
    notification.error({
        message: `请求错误`,
        description: errortext,
    });
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
};

const ajaxGet = (url) => {
    return new Promise((y, n) => {
        //创建xhr对象
        var xhr= new XMLHttpRequest();

        //         0(UNSENT):未初始化。尚未调用open()方法
        // 1(OPENED):启动。已经调用open()方法，但尚未调用send()方法
        // 2(HEADERS_RECEIVED):发送。己经调用send()方法，且接收到头信息
        // 3(LOADING):接收。已经接收到部分响应主体信息
        // 4(DONE):完成。已经接收到全部响应数据，而且已经可以在客户端使用了
        xhr.onreadystatechange = function () {
            //同步接受响应
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    y({ code: xhr.status })
                }
            }
        }
        xhr.ontimeout = function () {
            n();
        }
        //发送请求
        xhr.open('get', url, true);
        xhr.timeout = 5000;
        xhr.send();
    })
}


export const downloadFile = (url) =>{
    let rep;
    fetch(`${API_PREFIX}${url}`, {
            method: 'GET',
            headers: {...FIX_HEADERS}
        })
        .then((response) =>{rep = response;return response.blob()})
        .then(blob => {

            let time = moment().format("YYYY年MM月DD日HH点mm分")
            // console.log(rep.headers.get("Content-Disposition"),rep.headers.get("content-disposition"));
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = `btcdn-mcu2-${time}.zip`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();    
            a.remove();  //afterwards we remove the element again         
        });
}

const request = (url, method = "GET", headers = {}, data) => {
    let opts = { headers: {}, mode: 'cors' };
    opts.method = method;

    if (method == "POST" || method == "PUT") {
        // opts.headers.append('Content-Type', 'application/json');
        opts.headers = { 'content-type': 'application/json' };
    }
    for (var x in FIX_HEADERS)
        opts.headers[x] = FIX_HEADERS[x];
    for (var x in headers)
        opts.headers[x] = headers[x];
    if (data) {
        opts.body = JSON.stringify(data);
    }

    // console.log(`${API_PREFIX}${url}`, opts)
    return fetch(`${API_PREFIX}${url}`, opts)
        .then(checkStatus)
        .then(rep => {
            // console.log(rep)
            return rep.json();
        })
}

const Get = (url, headers) => {
    return request(url, "GET", headers, null);
}

const Post = (url, headers, data) => {
    return request(url, "POST", headers, data);
}

const Delete = (url, headers) => {
    return request(url, "DELETE", headers, null);
}

const Put = (url, headers, data) => {
    return request(url, "PUT", headers, data);
}
export default request;

export {
    Get, Post, Delete, Put, setFixHeader, ajaxGet,getFixHeader
}
